var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"9","viewBox":"0 0 10 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 8.66L2.5 4.33L0 0H5H10L7.5 4.33L5 8.66Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }